import {
  collection,
  doc,
  getDocs,
  limit,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "firebaseConfig";

const getSites = async (): Promise<SiteType[]> => {
  const querySnapshot = await getDocs(collection(db, "site"));
  return querySnapshot.docs.map((d) => ({ ...(d.data() as SiteType), id: d.id }));
};

//Get site ids by client
const getSiteIdsByClient = async (idClient: string): Promise<string[]> => {
  const q = query(collection(db, "site"), where("idclient", "==", idClient));
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((d) => d.id);
};

// Un forfait porte-t-il ce site ? Son client ne peut alors plus changer
const siteHasForfaits = async (idSite: string): Promise<boolean> => {
  const q = query(collection(db, "forfait"), where("idsites", "array-contains", idSite), limit(1));
  const querySnapshot = await getDocs(q);
  return !querySnapshot.empty;
};

// Un site s'archive au lieu d'être supprimé : les forfaits et les interventions gardent leur historique
const setSiteActif = async (idSite: string, actif: boolean) => {
  await updateDoc(doc(db, "site", idSite), { actif });
};

// Un Timestamp Firestore devient une date ; une valeur absente reste null
const versDate = (valeur: unknown): Date | null =>
  valeur && typeof (valeur as { toDate?: () => Date }).toDate === "function" ? (valeur as { toDate: () => Date }).toDate() : null;

// État de chaque site publié par n8n, lu en une fois pour la page Maintenance
const getSitesEtat = async (): Promise<SiteEtatType[]> => {
  const querySnapshot = await getDocs(collection(db, "site_etat"));
  return querySnapshot.docs.map((d) => {
    const data = d.data();
    const disponibilite = data.disponibilite;
    return {
      domaine: data.domaine ?? d.id,
      collecte: versDate(data.collecte),
      suivi: data.suivi ?? null,
      sauvegardes: (data.sauvegardes ?? []).map((tache: Record<string, unknown>) => ({
        ...tache,
        derniere_execution: versDate(tache.derniere_execution),
        dernier_succes: versDate(tache.dernier_succes),
      })),
      disponibilite: disponibilite
        ? { ...disponibilite, depuis: versDate(disponibilite.depuis), dernier_controle: versDate(disponibilite.dernier_controle) }
        : null,
    } as SiteEtatType;
  });
};

const siteApi = {
  getSites,
  getSitesEtat,
  getSiteIdsByClient,
  siteHasForfaits,
  setSiteActif,
};

// Fonctions définies une seule fois : référence stable, utilisable dans les dépendances des hooks React
export function useSite() {
  return siteApi;
}
